import React, { useEffect } from 'react';
import { DiagnosticoContext } from './DiagnosticoContext';
import { DiagnosticoReducer, initialState } from './DiagnosticoReducer';
import {
  setChartActionAsync,
  setFormDataInputsDiagnosticB,
  setLoadingChartAction,
  setIdActionAsync,
} from './DiagnosticoActions';
import {
  addDataChartsDiagnosticOneActionsAsync,
  queryDiagnosticAAction,
  queryFormDiagnosticBActionASync,
  setAnswerAction,
} from './LoadingActions';
import { useReducer } from 'reinspect';
import {
  changeEndOfDiagnosticStateAction,
  changeIntermediateTextStateAction,
  changeIntroductionStateAction,
} from './NavigateActions';

const DiagnosticoProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    DiagnosticoReducer,
    initialState,
    (s) => s,
    'diagnostico',
  );

  const setDataAnswers = async ({ dataAnswer }) => {
    await setAnswerAction.asyncExecuter({ dataAnswer })({
      dispatch,
      state,
    });
  };

  const setStateDataPdfDiagnosticOneFn = async ({ dataAnswer }) => {
    await addDataChartsDiagnosticOneActionsAsync.asyncExecuter({ dataAnswer })({
      dispatch,
      state,
    });
  };

  const setChatStateFn = async ({ chart }) => {
    await setChartActionAsync.asyncExecuter({
      ...state.chartCaptures,
      ...chart,
    })({ dispatch, state });
  };

  const changeStateShowIntroductionFn = (value) => {
    changeIntroductionStateAction.asyncExecuter(value)({
      dispatch,
      state,
    });
  };
  const changeStateShowIntermediateTextFn = (value) => {
    changeIntermediateTextStateAction.asyncExecuter(value)({
      dispatch,
      state,
    });
  };

  const changeStateEndOfDiagnosticFn = (value) => {
    changeEndOfDiagnosticStateAction.asyncExecuter(value)({
      dispatch,
      state,
    });
  };

  const setInfoForm = async ({ value, input }) => {
    await setFormDataInputsDiagnosticB.asyncExecuter({
      ...state.formDataInputsDiagnosticB,
      [input]: value,
    })({ dispatch, state });
  };

  const queryDiagnosticFn = async () => {
    await queryDiagnosticAAction.asyncExecuter({})({ dispatch, state });
  };

  const queryFormDiagnosticBFn = async (idFrom) => {
    await queryFormDiagnosticBActionASync.asyncExecuter({ idFrom })({
      dispatch,
      state,
    });
  };

  const idQuestionsFn = async (id) => {
    await setIdActionAsync.asyncExecuter(id)({
      dispatch,
      state,
    });
  };

  const setLoadingTextFn = async (stateAction) => {
    await setLoadingChartAction.asyncExecuter(stateAction)({ dispatch, state });
  };

  useEffect(() => {
    queryDiagnosticFn();
  }, []);

  return (
    <DiagnosticoContext.Provider
      value={{
        setDataAnswers,
        setStateDataPdfDiagnosticOneFn,
        setChatStateFn,
        changeStateShowIntroductionFn,
        changeStateShowIntermediateTextFn,
        changeStateEndOfDiagnosticFn,
        setInfoForm,
        setLoadingTextFn,
        queryFormDiagnosticBFn,
        idQuestionsFn,
        ...state,
      }}
    >
      {children}
    </DiagnosticoContext.Provider>
  );
};

export default DiagnosticoProvider;
